export default {
  title: {
    regular: 'Modificatori obișnuiți pentru produse',
    meal: 'Creează articolul ofertei de meniu',
    upsell: 'Creează grupul de upsell',
  },
  description: {
    regular:
      'Selectați modificatorii care vor fi incluși în noul grup dacă există deja în alt grup de modificatori. Puteți continua crearea grupului și adăuga modificatori ulterior.',
    meal: 'Selectați produsele incluse în oferta de meniu. Dacă nu există încă, creați-le pe pagina „Gestionare meniuri". Atașați articolul la produsele potrivite în secțiunea „Modificatori" din constructorul de produse.',
    upsell:
      'Selectați produsele incluse în grupul de upsell. Dacă nu există încă, creați-le pe pagina „Gestionare meniuri". Atașați articolul la produsele potrivite în secțiunea „Modificatori" din constructorul de produse.',
  },
  fields: {
    name: {
      label: 'Nume',
      placeholder: 'Introduceți numele grupului de modificatori',
    },
    max_quantity: {
      label: 'Cantitate maximă',
      placeholder: 'Cantitate maximă de modificatori',
    },
    is_required: {
      label: 'Obligatoriu',
    },
  },
  labels: {
    visible: 'Vizibil',
    hidden: 'Ascuns',
    multiply: 'Multiplicabil',
  },
  buttons: {
    save: 'Salvează',
    close: 'Închide',
  },
  toasts: {
    modifier_group_got_created: 'Grupul de modificatori a fost creat',
    modifier_group_got_updated: 'Grupul de modificatori a fost actualizat',
  },
};
